// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeSiteAccountApi = class EdgeSiteAccountApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param patientsSearchPatientsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientsSearchAllProgramPatients(patientsSearchPatientsRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchAllProgramPatients';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'patientsSearchPatientsRequestModel' is not null or undefined
        if (patientsSearchPatientsRequestModel === null || patientsSearchPatientsRequestModel === undefined) {
            throw new Error('Required parameter patientsSearchPatientsRequestModel was null or undefined when calling patientsSearchAllProgramPatients.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientsSearchPatientsRequestModel, "PatientsSearchPatientsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchAllProgramPatientsSearchAllProgramPatientsResponse");
        }
        return response;
    }
    /**
     *
     * @param accountsByCaseSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientsSearchPatientAccountsByCaseSearch(accountsByCaseSearchRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatientAccountsByCaseSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountsByCaseSearchRequestModel' is not null or undefined
        if (accountsByCaseSearchRequestModel === null || accountsByCaseSearchRequestModel === undefined) {
            throw new Error('Required parameter accountsByCaseSearchRequestModel was null or undefined when calling patientsSearchPatientAccountsByCaseSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(accountsByCaseSearchRequestModel, "AccountsByCaseSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientAccountsByCaseSearchSearchPatientAccountsByCaseSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param prescriberSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientsSearchPatientAccountsByPrescriber(prescriberSearchRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatientAccountsByPrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'prescriberSearchRequestModel' is not null or undefined
        if (prescriberSearchRequestModel === null || prescriberSearchRequestModel === undefined) {
            throw new Error('Required parameter prescriberSearchRequestModel was null or undefined when calling patientsSearchPatientAccountsByPrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberSearchRequestModel, "PrescriberSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientAccountsByPrescriberSearchPatientAccountsByPrescriberResponse");
        }
        return response;
    }
    /**
     *
     * @param patientsSearchPatientsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientsSearchPatients(patientsSearchPatientsRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatients';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'patientsSearchPatientsRequestModel' is not null or undefined
        if (patientsSearchPatientsRequestModel === null || patientsSearchPatientsRequestModel === undefined) {
            throw new Error('Required parameter patientsSearchPatientsRequestModel was null or undefined when calling patientsSearchPatients.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientsSearchPatientsRequestModel, "PatientsSearchPatientsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientsSearchPatientsResponse");
        }
        return response;
    }
    /**
     *
     * @param cancelWorkflowRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountCancelWorkflow(cancelWorkflowRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/CancelWorkflow';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'cancelWorkflowRequestModel' is not null or undefined
        if (cancelWorkflowRequestModel === null || cancelWorkflowRequestModel === undefined) {
            throw new Error('Required parameter cancelWorkflowRequestModel was null or undefined when calling siteAccountCancelWorkflow.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(cancelWorkflowRequestModel, "CancelWorkflowRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountCancelWorkflowDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param siteAccountRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountCreateSiteAccount(siteAccountRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/createSiteAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'siteAccountRequestModel' is not null or undefined
        if (siteAccountRequestModel === null || siteAccountRequestModel === undefined) {
            throw new Error('Required parameter siteAccountRequestModel was null or undefined when calling siteAccountCreateSiteAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteAccountRequestModel, "SiteAccountRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse");
        }
        return response;
    }
    /**
     *
     * @param getAccountRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountGetAccount(getAccountRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/GetAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getAccountRequestModel' is not null or undefined
        if (getAccountRequestModel === null || getAccountRequestModel === undefined) {
            throw new Error('Required parameter getAccountRequestModel was null or undefined when calling siteAccountGetAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getAccountRequestModel, "GetAccountRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param getCaseRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountGetCase(getCaseRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/GetCase';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getCaseRequestModel' is not null or undefined
        if (getCaseRequestModel === null || getCaseRequestModel === undefined) {
            throw new Error('Required parameter getCaseRequestModel was null or undefined when calling siteAccountGetCase.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getCaseRequestModel, "GetCaseRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetCaseDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param getCasesRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountGetCases(getCasesRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/GetCases';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getCasesRequestModel' is not null or undefined
        if (getCasesRequestModel === null || getCasesRequestModel === undefined) {
            throw new Error('Required parameter getCasesRequestModel was null or undefined when calling siteAccountGetCases.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getCasesRequestModel, "GetCasesRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetCasesDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountGetParty(body, xProgramId) {
        const _url_ = '/edge/siteAccount/GetParty';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling siteAccountGetParty.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetPartyDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountGetSiteAccount(body, xProgramId) {
        const _url_ = '/edge/siteAccount/GetSiteAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling siteAccountGetSiteAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetSiteAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param getWorkflowsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountGetWorkflows(getWorkflowsRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/GetWorkflows';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getWorkflowsRequestModel' is not null or undefined
        if (getWorkflowsRequestModel === null || getWorkflowsRequestModel === undefined) {
            throw new Error('Required parameter getWorkflowsRequestModel was null or undefined when calling siteAccountGetWorkflows.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getWorkflowsRequestModel, "GetWorkflowsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetWorkflowsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param searchAccountsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountSearchAccounts(searchAccountsRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/SearchAccounts';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'searchAccountsRequestModel' is not null or undefined
        if (searchAccountsRequestModel === null || searchAccountsRequestModel === undefined) {
            throw new Error('Required parameter searchAccountsRequestModel was null or undefined when calling siteAccountSearchAccounts.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(searchAccountsRequestModel, "SearchAccountsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSearchAccountsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param searchCasesRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountSearchCases(searchCasesRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/SearchCases';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'searchCasesRequestModel' is not null or undefined
        if (searchCasesRequestModel === null || searchCasesRequestModel === undefined) {
            throw new Error('Required parameter searchCasesRequestModel was null or undefined when calling siteAccountSearchCases.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(searchCasesRequestModel, "SearchCasesRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSearchCasesDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param searchWorkflowsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountSearchWorkflows(searchWorkflowsRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/SearchWorkflows';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'searchWorkflowsRequestModel' is not null or undefined
        if (searchWorkflowsRequestModel === null || searchWorkflowsRequestModel === undefined) {
            throw new Error('Required parameter searchWorkflowsRequestModel was null or undefined when calling siteAccountSearchWorkflows.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(searchWorkflowsRequestModel, "SearchWorkflowsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSearchWorkflowsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param siteAccountsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountSiteAccountsByPortalId(siteAccountsRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/siteAccountsByPortalId';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'siteAccountsRequestModel' is not null or undefined
        if (siteAccountsRequestModel === null || siteAccountsRequestModel === undefined) {
            throw new Error('Required parameter siteAccountsRequestModel was null or undefined when calling siteAccountSiteAccountsByPortalId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteAccountsRequestModel, "SiteAccountsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountSiteAccountsByPortalIdSiteAccountsByPortalIdResponse");
        }
        return response;
    }
    /**
     *
     * @param siteAccountsAlternateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountSiteAccountsByPortalIdAlternate(siteAccountsAlternateRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/siteAccountsByPortalIdAlternate';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'siteAccountsAlternateRequestModel' is not null or undefined
        if (siteAccountsAlternateRequestModel === null || siteAccountsAlternateRequestModel === undefined) {
            throw new Error('Required parameter siteAccountsAlternateRequestModel was null or undefined when calling siteAccountSiteAccountsByPortalIdAlternate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteAccountsAlternateRequestModel, "SiteAccountsAlternateRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountSiteAccountsByPortalIdAlternateSiteAccountsByPortalIdAlternateResponse");
        }
        return response;
    }
    /**
     *
     * @param iSiteRegistrationRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteAccountSiteRegistration(iSiteRegistrationRequestModel, xProgramId) {
        const _url_ = '/edge/siteAccount/SiteRegistration';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iSiteRegistrationRequestModel' is not null or undefined
        if (iSiteRegistrationRequestModel === null || iSiteRegistrationRequestModel === undefined) {
            throw new Error('Required parameter iSiteRegistrationRequestModel was null or undefined when calling siteAccountSiteRegistration.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iSiteRegistrationRequestModel, "ISiteRegistrationRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteRegistrationDefaultResponse");
        }
        return response;
    }
};
EdgeSiteAccountApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeSiteAccountApi);
export { EdgeSiteAccountApi };
//# sourceMappingURL=edgeSiteAccountApi.js.map